import { IReportOrderItemsItemRefund } from './types';

/**
 * check if an item or an item's children have been selected for a refund by checking the 'refundCount' property
 * @param {IReportOrderItemsItemRefund} item - data representing one row of checkbox (or a group of checkboxes) in the form
 */
export const isItemOrChildSelected = (item: IReportOrderItemsItemRefund) => {
  return item.children
    ? item.refundCount > 0 || item.children.some(isItemOrChildSelected)
    : item.refundCount > 0;
};
